<template>
  <div class="course-preview-page">
    <CoursePreview :course="course" />
  </div>
</template>

<script>
import CoursePreview from '@itbpbg/lms-components/src/Courses/Preview/Index';
import { loadHotJar } from '@itbpbg/lms-components/src/utils/helper';

export default {
  components: {
    CoursePreview,
  },
  async asyncData({
    $config, route, $axios, error,
  }) {
    const course = await $axios.$get(`/courses/${route.params.course}`).catch(() => false);

    if (!course) {
      return error({ statusCode: 404, message: 'Course not found' });
    }
    course.info = {};

    course.info.fullPath = `${$config.siteUrl}${route.fullPath}`;

    course.info.metaTitle = course.metaTitle;
    course.info.metaDescription = course.metaDescription;

    course.info.created = course.info.created || new Date();
    course.info.updated = course.info.updated || new Date();

    return { course };
  },
  mounted() {
    const coursesWithHotJar = {
      ds: [
        'intro-to-data-and-data-science',
        'data-strategy',
        'introduction-to-microsoft-excel',
        'statistics',
        'intro-to-chatgpt-and-generative-ai',
        'introduction-to-power-bi',
        'sql',
        'introduction-to-python',
        'python-programmer-bootcamp',
        'data-visualization',
        'machine-learning-in-python',
        'intro-to-nlp-for-ai',
        'credit-risk-modeling-in-python',
        'product-management-for-ai-data-science',
      ],
      fa: [
        'who-does-what-in-finance',
        'introduction-to-microsoft-excel',
        'math-for-finance',
        'accounting-and-financial-statement-analysis',
        'building-a-3-statement-model-in-excel',
        'fundamentals-of-financial-reporting',
        'financial-ratio-analysis',
        'fundamentals-of-equity-valuation',
        'fpa-building-a-company-budget',
        'investment-banking',
      ],
    };

    if (coursesWithHotJar[this.$config.platform] && coursesWithHotJar[this.$config.platform].includes(this.course.slug)) {
      loadHotJar();
    }
  },
};
</script>
<style lang="scss" scoped>
.header-sm {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 1;
  bottom: -96px;
  transition: ease all var(--duration);
  color: var(--main-light);
  background: var(--main-dark-shade-1);
  height: 96px;
  display: flex;
  align-items: center;
  padding: var(--spacing-14) var(--spacing-40);

  .img {
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;
    image-rendering: -webkit-optimize-contrast;
    width: 100px;
    height: 100%;
    border-radius: 4px;
    margin-right: var(--spacing-16);

    .tech-img {
      text-align: right;
      margin: 4px 4px 0 0;
      display: flex;
      justify-content: flex-end;

      svg {
        max-width: 11px;
      }
    }
  }

  .h5,
  p {
    margin: 0;
  }

  p {
    margin-top: var(--spacing-6);
  }

  p:not(.h5) {
    line-height: 150%;
    color: var(--main-light-shade-4);
  }

  .btn-primary {
    margin-left: auto;
  }

  &.fixed {
    bottom: 0;
    transition: ease all var(--duration);

    .btn-primary {
      padding-left: 50px;
      padding-right: 50px;
    }
  }

  @include bp($bp-mobile) {
    display: none;
  }
}
</style>
